import { FC, useMemo, useCallback } from 'react'
import { accountActionsMap, isProviderAccount } from 'helpers/linkageHelpers'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import { cancelMfaActionCreator } from 'actions/linkageActions'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionCancelHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionCancelHandler: FC<AccountActionCancelHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { providerAccountState, providerAccount } = accountInfo
  const { actions } = providerAccountState

  const dispatch = useStoreDispatch()

  const handleClick = useCallback(() => {
    if (isProviderAccount(providerAccount)) {
      dispatch(cancelMfaActionCreator.request(providerAccount))
    }
  }, [dispatch, providerAccount])

  const isExist = useMemo(() => {
    const actionsMap = accountActionsMap(actions)
    return !!actionsMap.cancel
  }, [actions])

  if (!isExist) {
    return null
  }

  return (
    <div onClick={ handleClick }>
      { children }
    </div>
  )
}
